<template>
<div>
    <div >
        <table style="width:100%;padding: 0 0 0 0; background-color: #fff;">
            <tr>
               
                <td><van-icon name="arrow-left" @click="onBackClick" size="1.5rem"/></td>
                <td>

                    <van-search
                    show-action
                   placeholder="请输入搜索关键词"
                   shape="round"
                    v-model="searchKey" 
                   >
                   <template #action>
                       <van-button plain type="info" round size="small" @click="onClickSearch">搜索</van-button>
                   </template>
               </van-search>
                </td>
            </tr>
        </table>
    </div>
    <div>
        <AppList v-show="hasLouFeng"  :colNum="4" :apps="apps" :fetchList="refreshAdvertList"></AppList>
    </div>
    <div>
        <van-cell-group   >
            <van-cell title="历史搜索" icon="underway-o">
                <template #right-icon>
                    <van-icon name="delete-o" class="search-icon" @click="clearHistoryKeys"/>
                </template>
            </van-cell> 

            <van-row type="flex" justify="center">
        
        <van-col span="5" v-for="index in oldKeys"  style="margin-top: 8px;" :key="index">
            <van-tag round color="#ddd" text-color="#111"  @click="onTagClick(index)">
                {{ index }}
            </van-tag>
        </van-col>
        
        </van-row>
        <br/>
        </van-cell-group>
 
        <van-cell-group   >
            <van-cell title="热门搜索" icon="fire-o" style="color:red;"> 
            </van-cell>
          

            <van-row type="flex" justify="center">
        
        <van-col span="5" v-for="index in hotKeys"  style="margin-top: 8px;" :key="index">
            <van-tag round type="primary"  @click="onTagClick(index)">
                {{ index }}
            </van-tag>
        </van-col>
        
        </van-row>
        <br/>
        </van-cell-group>
    </div>
 
   <div>
    <AppList :colNum="4" :apps="apps" :fetchList="refreshAdvertList"></AppList>
   </div>

</div>
</template>

<script>
import Utils from '@/utils/Utils';
import { Dialog } from 'vant';
import AppList from '@/components/AppList.vue';
import HttpHelper from '@/utils/HttpHelper';
import GlobalConfig from '@/utils/GlobalConfig';
export default {
    name:'SearchIndex',
    data(){
        return {
            searchKey:"",
            oldKeys:[],
            apps:[],
        }
    },

    components:{AppList},

    props:["handleSearch","handleBack"],

    mounted(){
        var keys = Utils.getLocalData("historySearch");

        if (keys) {
            this.oldKeys= JSON.parse(keys);
        }

        this.refreshAdvertList();
    },

    computed:{
        hasLouFeng(){
            return GlobalConfig.getInstance().hasLouFeng;
        },
        hotKeys(){
            return ["素人","白虎","少女","丰臀","无码","女仆","骑乘位","中出","口交","多P"];
        }
    },

    methods:{
        onBackClick(){
            if (this.handleBack) {
                this.handleBack();
                return;
            }

            this.$router.back();
        },

        addHistoryKey(key) {
            this.oldKeys.unshift(key);
            
            Utils.setLocalData("historySearch", JSON.stringify(this.oldKeys))
        },

        onClickSearch() {
            if (!this.searchKey.trim()) {
                console.log("search key is empty")
                return;
            }

            var idx = -1;
            for (var i = 0; i < this.oldKeys.length; i++){
                if (this.oldKeys[i] == this.searchKey.trim()) {
                    idx = i;
                    break;
                }
            }
           
            if (idx === -1) {
                this.addHistoryKey(this.searchKey.trim())
            }
                
            if (this.handleSearch) {
                var key = this.searchKey.trim();
                this.searchKey = "";

                this.handleSearch(key)
            } else {
                console.log("handleSearch is empty")
            }

            this.searchKey = "";
        },

        onTagClick(key) {
            this.searchKey = key;

            this.onClickSearch()
        },

        clearHistoryKeys(){
            if (!this.oldKeys || this.oldKeys.length < 1) return;

            Dialog.confirm({
                message: '确定删除所有历史搜索记录?',
                })
                .then(() => {
                    Utils.setLocalData("historySearch", "[]")
                    while (this.oldKeys.shift()) ;

                    this.oldKeys = [];
                })
                .catch(() => {
                    // on cancel
            });
 
        },

        refreshAdvertList(cb) {
                HttpHelper.queryAdvertList("", (code, data) =>{
                    if (code != 200) {
                        console.log("query icon fail ", code)
                        return;
                    }

                    if (data && data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            data[i].kind = 1
                            data[i].key = data[i].href;
                        }
                    }

                    while(this.apps.shift());

                    data.forEach((ele)=>{
                        this.apps.push(ele);
                    })

                    if (GlobalConfig.getInstance().hasLouFeng) {
                        this.apps.push(GlobalConfig.getInstance().louFengData);
                    }
                    
                    //this.finishLoad();

                    while(GlobalConfig.getInstance().iconAdverts.shift());

                    data.forEach((ele)=>{
                        GlobalConfig.getInstance().iconAdverts.push(ele);
                    })

                    if (cb)cb();
                });  
            }
    }
}
</script>